<div class="container-fluid" id="productTerms">
  <div class="section">
    <div class="product-terms-collapsible">
      <div class="hide-show-text-cpa">
        California Residents: Please click<a
          href="https://customer.creditacceptance.com/documents/20181/11647560/Notice+of+Collection+of+Information+-+California+Consumers2.pdf/fb103349-483b-cbdb-7991-99c1cdef0cb4"
          target="_blank"
          style="padding-left: 5px; padding-right: 5px"
          >here</a
        >for the Notice of Collection regarding the personal information Credit
        Acceptance may collect from you.
      </div>
      <div class="hide-show-text">
        <div class="product-dislosures-label">TERMS AND CONDITIONS</div>
        <div class="show-hide-text-top" tabindex="0">
          <div class="show-all-text" (click)="toggleTermsSection()">
            {{ this.showTermsSection ? 'Hide All -' : 'Show All +' }}
          </div>
        </div>
      </div>
      <div
        [ngClass]="
          this.showTermsSection ? 'show-product-terms' : 'hide-product-terms'
        "
        id="product-terms"
      >
        <div
          class="product-terms-body"
          [innerHTML]="productTerms | safeHtml"
        ></div>
      </div>
      <div class="show-hide-text-bottom" tabindex="0">
        <div
          class="show-all-text toggle-section"
          (click)="toggleTermsSection()"
        >
          {{ this.showTermsSection ? 'Hide All -' : 'Show All +' }}
        </div>
      </div>
    </div>
  </div>
</div>
